import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

type Props = {
  size?: number;
  speed?: number;
} & React.ComponentPropsWithRef<"svg">;

const Spinner = (props: Props, ref: React.Ref<SVGSVGElement>) => {
  const { size = 24, speed = 1, ...rest } = props;

  return (
    <Spinner.Styled
      ref={ref}
      width={size}
      height={size}
      speed={speed}
      {...rest}
      viewBox="0 0 19 19"
    >
      <path
        d="M9.5 0.7125C9.5 0.318997 9.18056 -0.00277953 8.78816 0.0267057C7.78434 0.102134 6.79732 0.33676 5.86451 0.723144C4.71191 1.20056 3.66464 1.90033 2.78248 2.78249C1.90033 3.66464 1.20056 4.71191 0.723144 5.86451C0.336759 6.79732 0.102134 7.78434 0.0267056 8.78816C-0.00277958 9.18056 0.318997 9.5 0.7125 9.5V9.5C1.106 9.5 1.42174 9.18039 1.45641 8.78842C1.52865 7.97189 1.72492 7.16971 2.03967 6.40983C2.44548 5.43013 3.04028 4.53995 3.79011 3.79011C4.53995 3.04028 5.43013 2.44548 6.40983 2.03967C7.1697 1.72492 7.97189 1.52865 8.78842 1.45641C9.18039 1.42174 9.5 1.106 9.5 0.7125V0.7125Z"
        fill="currentColor"
      />
    </Spinner.Styled>
  );
};

const rotate = keyframes`
    to {
        transform: rotate(360deg);
    }
`;

Spinner.Styled = styled.svg<{ speed?: number }>`
  animation: ${rotate} ${(props) => props.speed ?? 1}s linear infinite;
`;

export default Object.assign(React.forwardRef(Spinner), { Styled: Spinner.Styled });
